export default __webpack_public_path__ + "static/media/azure.b6231833.jpg";